import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  JSON: { input: any; output: any; }
};

export type Query = {
  __typename?: 'Query';
  cultureReportContent?: Maybe<CultureReport>;
};


export type QueryCultureReportContentArgs = {
  pageId?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type CultureReport = {
  __typename?: 'CultureReport';
  breakdownData?: Maybe<BreakdownData>;
  campaign?: Maybe<Campaign>;
  engagementData?: Maybe<EngagementData>;
  feedbackCount?: Maybe<Scalars['Int']['output']>;
  feedBackLink?: Maybe<Scalars['String']['output']>;
  hotspotData?: Maybe<HotspotData>;
  refCampaign?: Maybe<Campaign>;
  reference?: Maybe<CultureAssessmentResult>;
  seriesA?: Maybe<CultureAssessmentResult>;
  seriesB?: Maybe<CultureAssessmentResult>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type BreakdownData = {
  __typename?: 'BreakdownData';
  divisionData?: Maybe<BreakdownDataSet>;
  jobLevelData?: Maybe<BreakdownDataSet>;
  locationData?: Maybe<BreakdownDataSet>;
};

export type BreakdownDataSet = {
  __typename?: 'BreakdownDataSet';
  current?: Maybe<Array<Maybe<BreakdownValues>>>;
  desired?: Maybe<Array<Maybe<BreakdownValues>>>;
};

export type BreakdownValues = {
  __typename?: 'BreakdownValues';
  color?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  filterString?: Maybe<Scalars['String']['output']>;
  indented?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  selected?: Maybe<Scalars['Boolean']['output']>;
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type Campaign = {
  __typename?: 'Campaign';
  allRespondents?: Maybe<Scalars['Boolean']['output']>;
  closedBy?: Maybe<Scalars['String']['output']>;
  closedDate?: Maybe<Scalars['String']['output']>;
  closingMessage?: Maybe<Scalars['String']['output']>;
  completionRate?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  emailText?: Maybe<Scalars['String']['output']>;
  excludeEmployees?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hasPlaceholders?: Maybe<Scalars['Boolean']['output']>;
  introduction?: Maybe<Scalars['String']['output']>;
  lastSaved?: Maybe<Scalars['String']['output']>;
  milestones?: Maybe<Array<Maybe<Milestone>>>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  publishDate?: Maybe<Scalars['String']['output']>;
  purpose?: Maybe<Scalars['String']['output']>;
  recipients?: Maybe<Scalars['String']['output']>;
  respondents?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  responses?: Maybe<Scalars['String']['output']>;
  selectedAssessments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sponsorName?: Maybe<Scalars['String']['output']>;
  sponsorTitle?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  superCharged?: Maybe<Scalars['Boolean']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type Milestone = {
  __typename?: 'Milestone';
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type EngagementData = {
  __typename?: 'EngagementData';
  completedUsersCount?: Maybe<Scalars['Int']['output']>;
  perceptionAverage?: Maybe<Perception>;
  perceptionList?: Maybe<Array<Maybe<Perception>>>;
  totalUsersCompleted?: Maybe<Scalars['Int']['output']>;
};

export type Perception = {
  __typename?: 'Perception';
  customerQuality?: Maybe<Scalars['Float']['output']>;
  financial?: Maybe<Scalars['Float']['output']>;
  jobEngagement?: Maybe<Scalars['Float']['output']>;
  jobSatisfaction?: Maybe<Scalars['Float']['output']>;
  learningGrowth?: Maybe<Scalars['Float']['output']>;
  operational?: Maybe<Scalars['Float']['output']>;
  overallClimate?: Maybe<Scalars['Float']['output']>;
  turnoverIntention?: Maybe<Scalars['Float']['output']>;
  workMotivation?: Maybe<Scalars['Float']['output']>;
};

export type HotspotData = {
  __typename?: 'HotspotData';
  divisionData?: Maybe<Array<Maybe<CultureHotspot>>>;
  jobLevelData?: Maybe<Array<Maybe<CultureHotspot>>>;
  locationData?: Maybe<Array<Maybe<CultureHotspot>>>;
  orgData?: Maybe<CultureHotspot>;
};

export type CultureHotspot = {
  __typename?: 'CultureHotspot';
  aggregateFilter?: Maybe<Scalars['String']['output']>;
  aggregation?: Maybe<Scalars['String']['output']>;
  current?: Maybe<Scalars['JSON']['output']>;
  desired?: Maybe<Scalars['JSON']['output']>;
  dimensions?: Maybe<Scalars['JSON']['output']>;
  hasParent?: Maybe<Scalars['Boolean']['output']>;
  responseCount?: Maybe<Scalars['Int']['output']>;
};

export type CultureAssessmentResult = {
  __typename?: 'CultureAssessmentResult';
  average?: Maybe<CultureResult>;
  results?: Maybe<CultureResultArray>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type CultureResult = {
  __typename?: 'CultureResult';
  accepting?: Maybe<Scalars['Float']['output']>;
  conformity?: Maybe<Scalars['Float']['output']>;
  control?: Maybe<Scalars['Float']['output']>;
  cooperation?: Maybe<Scalars['Float']['output']>;
  driver?: Maybe<Scalars['Float']['output']>;
  focus?: Maybe<Scalars['Float']['output']>;
  formal?: Maybe<Scalars['Float']['output']>;
  internalExternal?: Maybe<Scalars['Float']['output']>;
  responsivePlanned?: Maybe<Scalars['Float']['output']>;
  riskTolerance?: Maybe<Scalars['Float']['output']>;
  structure?: Maybe<Scalars['Float']['output']>;
  teamWork?: Maybe<Scalars['Float']['output']>;
};

export type CultureResultArray = {
  __typename?: 'CultureResultArray';
  accepting?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  conformity?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  control?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  cooperation?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  driver?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  focus?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  formal?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  internalExternal?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  responsivePlanned?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  riskTolerance?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  structure?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  teamWork?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type CultureReportContentQueryVariables = Exact<{
  password?: InputMaybe<Scalars['String']['input']>;
  pageId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CultureReportContentQuery = { __typename?: 'Query', cultureReportContent?: { __typename?: 'CultureReport', status?: string | null, title?: string | null, feedBackLink?: string | null, feedbackCount?: number | null, breakdownData?: { __typename?: 'BreakdownData', divisionData?: { __typename?: 'BreakdownDataSet', desired?: Array<{ __typename?: 'BreakdownValues', name?: string | null, filterString?: string | null, indented?: boolean | null, selected?: boolean | null, color?: string | null, values?: Array<number | null> | null, count?: number | null } | null> | null, current?: Array<{ __typename?: 'BreakdownValues', name?: string | null, filterString?: string | null, indented?: boolean | null, selected?: boolean | null, color?: string | null, values?: Array<number | null> | null, count?: number | null } | null> | null } | null, locationData?: { __typename?: 'BreakdownDataSet', current?: Array<{ __typename?: 'BreakdownValues', name?: string | null, filterString?: string | null, indented?: boolean | null, selected?: boolean | null, color?: string | null, values?: Array<number | null> | null, count?: number | null } | null> | null, desired?: Array<{ __typename?: 'BreakdownValues', name?: string | null, filterString?: string | null, indented?: boolean | null, selected?: boolean | null, color?: string | null, values?: Array<number | null> | null, count?: number | null } | null> | null } | null, jobLevelData?: { __typename?: 'BreakdownDataSet', current?: Array<{ __typename?: 'BreakdownValues', name?: string | null, filterString?: string | null, indented?: boolean | null, selected?: boolean | null, color?: string | null, values?: Array<number | null> | null, count?: number | null } | null> | null, desired?: Array<{ __typename?: 'BreakdownValues', name?: string | null, filterString?: string | null, indented?: boolean | null, selected?: boolean | null, color?: string | null, values?: Array<number | null> | null, count?: number | null } | null> | null } | null } | null, campaign?: { __typename?: 'Campaign', name?: string | null, dueDate?: string | null, createdDate?: string | null, emailText?: string | null, status?: string | null, respondents?: Array<string | null> | null, allRespondents?: boolean | null, excludeEmployees?: Array<string | null> | null, lastSaved?: string | null, completionRate?: string | null, recipients?: string | null, responses?: string | null, publishDate?: string | null, closedBy?: string | null, closedDate?: string | null, purpose?: string | null, note?: string | null, timezone?: string | null, introduction?: string | null, closingMessage?: string | null, selectedAssessments?: Array<string | null> | null, sponsorName?: string | null, sponsorTitle?: string | null, superCharged?: boolean | null, hasPlaceholders?: boolean | null, milestones?: Array<{ __typename?: 'Milestone', description?: string | null, startDate?: string | null, endDate?: string | null } | null> | null } | null, refCampaign?: { __typename?: 'Campaign', name?: string | null, dueDate?: string | null, createdDate?: string | null, emailText?: string | null, status?: string | null, respondents?: Array<string | null> | null, allRespondents?: boolean | null, excludeEmployees?: Array<string | null> | null, lastSaved?: string | null, completionRate?: string | null, recipients?: string | null, responses?: string | null, publishDate?: string | null, closedBy?: string | null, closedDate?: string | null, purpose?: string | null, note?: string | null, timezone?: string | null, introduction?: string | null, closingMessage?: string | null, selectedAssessments?: Array<string | null> | null, sponsorName?: string | null, sponsorTitle?: string | null, superCharged?: boolean | null, hasPlaceholders?: boolean | null } | null, seriesA?: { __typename?: 'CultureAssessmentResult', totalResults?: number | null, average?: { __typename?: 'CultureResult', riskTolerance?: number | null, driver?: number | null, focus?: number | null, teamWork?: number | null, control?: number | null, structure?: number | null, responsivePlanned?: number | null, conformity?: number | null, accepting?: number | null, cooperation?: number | null, internalExternal?: number | null, formal?: number | null } | null, results?: { __typename?: 'CultureResultArray', riskTolerance?: Array<number | null> | null, driver?: Array<number | null> | null, focus?: Array<number | null> | null, teamWork?: Array<number | null> | null, control?: Array<number | null> | null, structure?: Array<number | null> | null, responsivePlanned?: Array<number | null> | null, conformity?: Array<number | null> | null, accepting?: Array<number | null> | null, cooperation?: Array<number | null> | null, internalExternal?: Array<number | null> | null, formal?: Array<number | null> | null } | null } | null, seriesB?: { __typename?: 'CultureAssessmentResult', totalResults?: number | null, average?: { __typename?: 'CultureResult', riskTolerance?: number | null, driver?: number | null, focus?: number | null, teamWork?: number | null, control?: number | null, structure?: number | null, responsivePlanned?: number | null, conformity?: number | null, accepting?: number | null, cooperation?: number | null, internalExternal?: number | null, formal?: number | null } | null, results?: { __typename?: 'CultureResultArray', riskTolerance?: Array<number | null> | null, driver?: Array<number | null> | null, focus?: Array<number | null> | null, teamWork?: Array<number | null> | null, control?: Array<number | null> | null, structure?: Array<number | null> | null, responsivePlanned?: Array<number | null> | null, conformity?: Array<number | null> | null, accepting?: Array<number | null> | null, cooperation?: Array<number | null> | null, internalExternal?: Array<number | null> | null, formal?: Array<number | null> | null } | null } | null, reference?: { __typename?: 'CultureAssessmentResult', totalResults?: number | null, average?: { __typename?: 'CultureResult', riskTolerance?: number | null, driver?: number | null, focus?: number | null, teamWork?: number | null, control?: number | null, structure?: number | null, responsivePlanned?: number | null, conformity?: number | null, accepting?: number | null, cooperation?: number | null, internalExternal?: number | null, formal?: number | null } | null, results?: { __typename?: 'CultureResultArray', riskTolerance?: Array<number | null> | null, driver?: Array<number | null> | null, focus?: Array<number | null> | null, teamWork?: Array<number | null> | null, control?: Array<number | null> | null, structure?: Array<number | null> | null, responsivePlanned?: Array<number | null> | null, conformity?: Array<number | null> | null, accepting?: Array<number | null> | null, cooperation?: Array<number | null> | null, internalExternal?: Array<number | null> | null, formal?: Array<number | null> | null } | null } | null, hotspotData?: { __typename?: 'HotspotData', orgData?: { __typename?: 'CultureHotspot', responseCount?: number | null, aggregation?: string | null, dimensions?: any | null, current?: any | null, desired?: any | null, hasParent?: boolean | null, aggregateFilter?: string | null } | null, divisionData?: Array<{ __typename?: 'CultureHotspot', responseCount?: number | null, aggregation?: string | null, dimensions?: any | null, current?: any | null, desired?: any | null, hasParent?: boolean | null, aggregateFilter?: string | null } | null> | null, locationData?: Array<{ __typename?: 'CultureHotspot', responseCount?: number | null, aggregation?: string | null, dimensions?: any | null, current?: any | null, desired?: any | null, hasParent?: boolean | null, aggregateFilter?: string | null } | null> | null, jobLevelData?: Array<{ __typename?: 'CultureHotspot', responseCount?: number | null, aggregation?: string | null, dimensions?: any | null, current?: any | null, desired?: any | null, hasParent?: boolean | null, aggregateFilter?: string | null } | null> | null } | null, engagementData?: { __typename?: 'EngagementData', totalUsersCompleted?: number | null, completedUsersCount?: number | null, perceptionAverage?: { __typename?: 'Perception', financial?: number | null, operational?: number | null, learningGrowth?: number | null, customerQuality?: number | null, jobEngagement?: number | null, jobSatisfaction?: number | null, turnoverIntention?: number | null, workMotivation?: number | null, overallClimate?: number | null } | null, perceptionList?: Array<{ __typename?: 'Perception', financial?: number | null, operational?: number | null, learningGrowth?: number | null, customerQuality?: number | null, jobEngagement?: number | null, jobSatisfaction?: number | null, turnoverIntention?: number | null, workMotivation?: number | null, overallClimate?: number | null } | null> | null } | null } | null };


export const CultureReportContentDocument = gql`
    query CultureReportContent($password: String, $pageId: String) {
  cultureReportContent(password: $password, pageId: $pageId) {
    status
    title
    breakdownData {
      divisionData {
        desired {
          name
          filterString
          indented
          selected
          color
          values
          count
        }
        current {
          name
          filterString
          indented
          selected
          color
          values
          count
        }
      }
      locationData {
        current {
          name
          filterString
          indented
          selected
          color
          values
          count
        }
        desired {
          name
          filterString
          indented
          selected
          color
          values
          count
        }
      }
      jobLevelData {
        current {
          name
          filterString
          indented
          selected
          color
          values
          count
        }
        desired {
          name
          filterString
          indented
          selected
          color
          values
          count
        }
      }
    }
    campaign {
      name
      dueDate
      createdDate
      emailText
      status
      respondents
      allRespondents
      excludeEmployees
      lastSaved
      completionRate
      recipients
      responses
      publishDate
      closedBy
      closedDate
      purpose
      note
      timezone
      introduction
      closingMessage
      selectedAssessments
      sponsorName
      sponsorTitle
      superCharged
      hasPlaceholders
      milestones {
        description
        startDate
        endDate
      }
    }
    refCampaign {
      name
      dueDate
      createdDate
      emailText
      status
      respondents
      allRespondents
      excludeEmployees
      lastSaved
      completionRate
      recipients
      responses
      publishDate
      closedBy
      closedDate
      purpose
      note
      timezone
      introduction
      closingMessage
      selectedAssessments
      sponsorName
      sponsorTitle
      superCharged
      hasPlaceholders
    }
    seriesA {
      totalResults
      average {
        riskTolerance
        driver
        focus
        teamWork
        control
        structure
        responsivePlanned
        conformity
        accepting
        cooperation
        internalExternal
        formal
      }
      results {
        riskTolerance
        driver
        focus
        teamWork
        control
        structure
        responsivePlanned
        conformity
        accepting
        cooperation
        internalExternal
        formal
      }
    }
    seriesB {
      totalResults
      average {
        riskTolerance
        driver
        focus
        teamWork
        control
        structure
        responsivePlanned
        conformity
        accepting
        cooperation
        internalExternal
        formal
      }
      results {
        riskTolerance
        driver
        focus
        teamWork
        control
        structure
        responsivePlanned
        conformity
        accepting
        cooperation
        internalExternal
        formal
      }
    }
    reference {
      totalResults
      average {
        riskTolerance
        driver
        focus
        teamWork
        control
        structure
        responsivePlanned
        conformity
        accepting
        cooperation
        internalExternal
        formal
      }
      results {
        riskTolerance
        driver
        focus
        teamWork
        control
        structure
        responsivePlanned
        conformity
        accepting
        cooperation
        internalExternal
        formal
      }
    }
    hotspotData {
      orgData {
        responseCount
        aggregation
        dimensions
        current
        desired
        hasParent
        aggregateFilter
      }
      divisionData {
        responseCount
        aggregation
        dimensions
        current
        desired
        hasParent
        aggregateFilter
      }
      locationData {
        responseCount
        aggregation
        dimensions
        current
        desired
        hasParent
        aggregateFilter
      }
      jobLevelData {
        responseCount
        aggregation
        dimensions
        current
        desired
        hasParent
        aggregateFilter
      }
    }
    engagementData {
      perceptionAverage {
        financial
        operational
        learningGrowth
        customerQuality
        jobEngagement
        jobSatisfaction
        turnoverIntention
        workMotivation
        overallClimate
      }
      perceptionList {
        financial
        operational
        learningGrowth
        customerQuality
        jobEngagement
        jobSatisfaction
        turnoverIntention
        workMotivation
        overallClimate
      }
      totalUsersCompleted
      completedUsersCount
    }
    feedBackLink
    feedbackCount
  }
}
    `;

/**
 * __useCultureReportContentQuery__
 *
 * To run a query within a React component, call `useCultureReportContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCultureReportContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCultureReportContentQuery({
 *   variables: {
 *      password: // value for 'password'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useCultureReportContentQuery(baseOptions?: Apollo.QueryHookOptions<CultureReportContentQuery, CultureReportContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CultureReportContentQuery, CultureReportContentQueryVariables>(CultureReportContentDocument, options);
      }
export function useCultureReportContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CultureReportContentQuery, CultureReportContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CultureReportContentQuery, CultureReportContentQueryVariables>(CultureReportContentDocument, options);
        }
export type CultureReportContentQueryHookResult = ReturnType<typeof useCultureReportContentQuery>;
export type CultureReportContentLazyQueryHookResult = ReturnType<typeof useCultureReportContentLazyQuery>;
export type CultureReportContentQueryResult = Apollo.QueryResult<CultureReportContentQuery, CultureReportContentQueryVariables>;